import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/how-to-make-halloween-profitable';

export default function Example() {
  return (
    <>
      <Head>
        <title>Spooky Season: How You Can Sell and Earn More in Halloween</title>
        <meta
          name='description'
          content='Stocking up on season-relevant items helps you attract the attention of potential buyers and close sales. Here’s a guide on how to do it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/how-to-make-halloween-profitable' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/how-to-make-halloween-profitable' />
        <meta property='og:title' content='Spooky Season: How You Can Sell and Earn More in Halloween' />
        <meta
          property='og:description'
          content='Stocking up on season-relevant items helps you attract the attention of potential buyers and close sales. Here’s a guide on how to do it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-09-07T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-09-07T00:00:00-00:00' />
        <meta property='article:tag' content='-' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
